import axios from 'axios'

export default {
  searchUpForm(path, formData) {
    console.log(path, formData)
    const params = { params: formData }
    return axios.get(path, params)
  }
}
